import React from 'react';

const StatCard = ({ label, value, valueColor = 'text-slate-900', sub }) => (
  <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm flex flex-col justify-between min-h-[100px]">
    <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{label}</span>
    <div>
      <span className={`text-4xl font-bold ${valueColor} mt-2 block`}>{value}</span>
      {sub && <span className="text-xs text-slate-400 mt-1 block">{sub}</span>}
    </div>
  </div>
);

export default StatCard;